module.exports = __webpack_public_path__ + "img/syukyaku-gyoumu-ira001.c92f4f58.png";